export default {
  // TeacherConv.vue
  teacherConv: {
    betaChip: 'BETA',
    teacherTitle: 'Your Tokatab teacher',
    plugPianoInfo: 'To connect your piano, you need to identify which port is present on the piano. There are generally 2 types of ports: midi ports and USB ports. Click on the button below to access a guided questionnaire that will help you identify the best solution, depending on your piano.',
    plugPianoButton: 'How to connect my piano?',
    skillRecommendationTitle: 'Here are the skills I recommend you work on:',
    skillCategoriesTitle: 'Choose a skill category to explore:',
    skillsCount: '{count} skill{plural}',
    goToPlayerButton: 'Go to the player',
    showParameterButton: 'Show how to change the parameter',
    contactTeamButton: 'Contact the Tokatab team',
    waitingLong: 'The Tokatab teacher sometimes takes time to think, a little patience...',
    waitingTooLong: 'The Tokatab teacher may have had a problem. You can cancel and try again.',
    cancelButton: 'Cancel',
    messagesRecordedNotice: 'Messages may be recorded to improve the teacher.',
    messagesRemaining: 'Messages remaining: {current}/{total} this week',
    inputPlaceholderQuotaExceeded: 'Message quota exhausted this week',
    inputPlaceholderDisabled: 'The teacher is writing...',
    inputPlaceholder: 'Talk with the Tokatab teacher',
    quotaExceededMessage: 'You have exhausted your message quota with the teacher this week. Subscribe to Tokatab premium for unlimited messages!',
    subscribeButton: 'Subscribe',
    betaWarningTitle: 'The Tokatab teacher is in experimental version, feel free to write to us to tell us what you think!',
    betaWarningButton: 'Start the discussion',
    conversationStarters: {
      dontKnowWhatToPlay: 'I don\'t know which song to play.',
      cantPlayBothHands: 'I can\'t play with both hands together.',
      playFrequency: 'How often should I play?',
      plugPiano: 'How to connect my piano?',
      positioning: 'How to position myself properly to play?',
      levelTest: 'I want to take the level test.',
      cantFindLessons: 'I can\'t find the lessons.',
      cantHearSound: 'I can\'t hear the sound well.',
      lowerTempo: 'How to lower the tempo?',
      showNoteNames: 'How to display note names?',
      whatSkillsToWork: 'What skills should I work on?',
      helpChooseSkill: 'Help me choose a skill to develop.'
    }
  },

  // TeacherChatBubble.vue
  teacherChatBubble: {
    retryButton: 'Try again',
    increaseTempo: 'Increase tempo',
    trySlower: 'Try slower',
    activateListeningQuestion: 'You haven\'t activated listening mode, would you like to activate it?',
    activateButton: 'Activate',
    dontAskAgainButton: 'Don\'t ask me again',
    noThanksButton: 'No thanks'
  },

  // TeacherKeywordExplainer.vue
  teacherKeywordExplainer: {
    explainTooltip: 'Explain this term',
    explainPrompt: 'Explain this term to me: {keyword}'
  },

  // TeacherChatbot.vue
  teacherChatbot: {
    welcomeMessage: 'Hi! I\'m the Tokatab piano teacher, how can I help you?',
    premiumNotification: 'You have exhausted your message quota with the teacher this week. Subscribe to Tokatab premium for unlimited messages!',
    subscribeButton: 'Subscribe',
    pageCaptureError: 'Error capturing page content:'
  },

  // TeacherService.ts
  teacherService: {
    redirecting: 'I\'m redirecting you to the requested page.',
    paused: 'I paused the song.',
    restarted: 'I restarted the song.',
    started: 'I started the song.',
    validated: 'Bravo, I validated the current content!',
    tempoSlowed: 'I slowed down the tempo of the song.',
    tempoIncreased: 'I increased the tempo of the song.',
    tempoModified: 'I modified the tempo of the song.',
    volumeIncreased: 'I increased the requested volume.',
    volumeDecreased: 'I decreased the requested volume.',
    volumeActivated: 'I activated the requested volume.',
    volumeDeactivated: 'I deactivated the requested volume.'
  },

  // TeacherSpeechRecognition.vue
  teacherSpeechRecognition: {
    notAvailable: 'Listening mode is not available in this browser. Please use another browser (Google Chrome, Safari, Edge, etc.)',
    listeningActivated: 'Listening mode activated, speak to send me a message.',
    listeningDeactivated: 'I deactivated listening mode.'
  }
}